import { Typography } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { colors } from '@/utils';

/** Readings stay on one line so the header truncates the camera/pen name instead. */
export const StyledSensorValue = styled(Typography)`
  color: ${colors.text.neutral.on.solid[100]};
  white-space: nowrap;
`;
